/**
 * V620: 缓存诊断工具 - 用于调试缓存问题
 */

export function diagnoseCache(): {
  localStorageKeys: string[];
  indexedDBSupported: boolean;
  cacheEntries: Array<{ key: string; data: any }>;
} {
  const result = {
    localStorageKeys: [] as string[],
    indexedDBSupported: typeof indexedDB !== 'undefined',
    cacheEntries: [] as Array<{ key: string; data: any }>,
  };

  // 检查 localStorage
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('avalon_stats:')) {
      result.localStorageKeys.push(key);
      try {
        const value = localStorage.getItem(key) || '';
        const entry = JSON.parse(value);
        result.cacheEntries.push({
          key,
          data: {
            timestamp: entry.timestamp,
            version: entry.version,
            tier: entry.tier,
            age: Date.now() - entry.timestamp,
            ttl: entry.tier ? 
              ({ hot: 2*60*1000, warm: 15*60*1000, cold: 24*60*60*1000 } as Record<string, number>)[entry.tier] : 
              5*60*1000,
          },
        });
      } catch (err) {
        result.cacheEntries.push({ key, data: { error: '解析失败' } });
      }
    }
  }

  return result;
}

export function clearAllAvalonCache(): void {
  console.log('[V620] 开始清理所有 Avalon 缓存...');
  const keysToRemove: string[] = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('avalon_stats:')) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
  console.log(`[V620] 已从 localStorage 清理 ${keysToRemove.length} 条缓存:`, keysToRemove);
  
  // 清理 IndexedDB
  if (typeof indexedDB !== 'undefined') {
    const request = indexedDB.deleteDatabase('AvalonStatsCache');
    request.onsuccess = () => {
      console.log('[V620] 已删除 IndexedDB: AvalonStatsCache');
    };
    request.onerror = () => {
      console.error('[V620] 删除 IndexedDB 失败:', request.error);
    };
  }
}
